module.exports = __webpack_public_path__ + "img/gabarito.8eed1873.png";